import { PermissionGate } from "@/components/common/PermissionGate"
import { Button } from "@/components/ui/button"
import { PERMISSIONS } from "@/constants/permissions"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { FilePlus2, UploadCloud } from "lucide-react"
import { Link } from "react-router"
import {
  EMPTY_CUSTOMER_DASHBOARD_STATS,
  useCustomerDashboard,
} from "../../../api/customerDashboardApi"
import { DashboardBoard } from "../../shared/dashboard/DashboardBoard"
import { conformityCreatePath, customerRequestImportPath } from "../routes"
import { useCustomerDashboardStore } from "./dashboard/customerDashboardStore"
import { DASHBOARD_WIDGETS } from "./dashboard/customerWidgetRegistry"

export function CustomerDashboardPage() {
  const { translate } = useTranslation()
  const { data, isLoading, isError, refetch } = useCustomerDashboard()
  return (
    <DashboardBoard
      agentTarget="customer-studio.dashboard"
      titleKey="MC_CSD_TITLE"
      helpArticle={{
        categoryId: "customer-studio",
        articleId: "customer.dashboard",
      }}
      headerActions={
        <>
          <PermissionGate
            permission={PERMISSIONS.MC_CUSTOMER_DECLARATIONS_GENERATE}
          >
            <Button
              asChild
              variant="default"
              size="sm"
              className="h-8 gap-1.5 bg-yellow1 px-3.5 text-[13px] font-semibold text-black hover:bg-yellow2"
            >
              <Link to={conformityCreatePath()}>
                <FilePlus2 size={14} />
                {translate("MC_CONFORMITY_BTN_GENERATE")}
              </Link>
            </Button>
          </PermissionGate>
          <PermissionGate permission={PERMISSIONS.MC_QUESTIONNAIRES_PROCESS}>
            <Button
              asChild
              variant="default"
              size="sm"
              className="h-8 gap-1.5 bg-yellow1 px-3.5 text-[13px] font-semibold text-black hover:bg-yellow2"
            >
              <Link to={customerRequestImportPath}>
                <UploadCloud size={14} />
                {translate("MC_Q_BTN_RECEIVE")}
              </Link>
            </Button>
          </PermissionGate>
        </>
      }
      useStore={useCustomerDashboardStore}
      widgets={DASHBOARD_WIDGETS}
      stats={data ?? EMPTY_CUSTOMER_DASHBOARD_STATS}
      isLoading={isLoading}
      isError={isError}
      refetch={refetch}
    />
  )
}
